<script>
	import { initPage } from "src/store/store";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { Row, Col } from "@sveltestrap/sveltestrap";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import { onDestroy } from "svelte";
	import { convertDateTime } from "src/services/helpers";

	export let changeSearchParams = () => {};
	export let handleVehicleSearch = () => {};
	export let params = {};

	$: plateNo = "";
	let vehicleId = "";
	let dateReported = "";
	let lastReviewedStart = "";
	let lastReviewedEnd = "";

	function handleChange(value) {
		changeSearchParams(value);
		initPage.set(1);
	}

	function resetFilter() {
		plateNo = "";
		vehicleId = "";
		dateReported = "";
		lastReviewedStart = "";
		lastReviewedEnd = "";
		changeSearchParams("");
	}

	$: if (params.dateReported) {
		dateReported = params.dateReported;
	} else {
		dateReported = "";
	}

	$: if (params.plateNo && params.vehicleId) {
		plateNo = params.plateNo;
		vehicleId = params.vehicleId;
	} else {
		plateNo = "";
		vehicleId = "";
	}

	$: if (params.lastReviewedStart && params.lastReviewedEnd) {
		lastReviewedEnd = params.lastReviewedEnd;
		lastReviewedStart = params.lastReviewedStart;
	} else {
		lastReviewedStart = "";
		lastReviewedEnd = "";
	}

	onDestroy(() => {
		plateNo = "";
		vehicleId = "";
		dateReported = "";
		lastReviewedStart = "";
		lastReviewedEnd = "";
	});
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={9}>
				<Row>
					<Col xs={3}>
						<CustomDatePicker
							name="dateReported"
							placeholder={"Date Reported"}
							value={dateReported}
							onChange={(e) =>
								handleChange({
									dateReported: e.detail,
								})}
							isRange={false}
						/>
					</Col>
					<Col xs={3}>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle no.`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col xs={4}>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									lastReviewedStart: e.detail[0],
									lastReviewedEnd: e.detail[1],
								});
								lastReviewedStart = e.detail[0];
								lastReviewedEnd = e.detail[1];
							}}
							name="lastReviewedStart"
							isRange={true}
							placeholder={"Last Reviewed"}
							value={lastReviewedStart && lastReviewedEnd
								? [lastReviewedStart, lastReviewedEnd]
								: ""}
						/>
					</Col>
					<Col xs={2} class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							textStyle="width: max-content;"
							buttonText="Clear filters"
							on:click={resetFilter}
							color="secondary"
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={3} style="position:relative; padding-right:0">
				<LimitSize />

				<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
				<div class="d-flex justify-content-end">
					<span
						class="on-surface-variant"
						style="text-align: end; white-space: nowrap"
						>Last updated
						{convertDateTime(new Date(), "MMM D, h:mm A")}
					</span>
				</div>
			</Col>
		</Row>
	</Col>
</Row>
